module.exports = __webpack_public_path__ + "img/submit_btn.c679be9e.png";